import { mapActions } from "vuex";
import AppIcon from "@/components/AppIcon";
import EditPageContentPreview from "@/components/EditPageContentPreview";
import EditPageContentEdit from "@/components/EditPageContentEdit";
import { OnClickOutside } from "@vueuse/components";
import DiffMatchPatch from "diff-match-patch";
import { generateHtmlDiff } from "@/utils";
import { countries_browser_languages } from "@/utils/countries";
export default {
  name: "EditpageContent",
  emits: ["update:modelValue", "hide-comparison", "checkIsValid"],
  components: {
    AppIcon,
    EditPageContentPreview,
    EditPageContentEdit,
    OnClickOutside
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {}
    },
    amazon: {
      type: Object,
      default: () => {}
    },
    ai_translated_content: {
      type: Object,
      default: () => {}
    },
    ai_generated_content: {
      type: Object,
      default: () => {}
    },
    ai_generated_content_translation: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    active_menu: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    show_ai_generated_content: {
      type: Boolean,
      default: false
    },
    show_ai_translated_content: {
      type: Boolean,
      default: false
    },
    omny_translated_content: {
      type: Object,
      default: () => {}
    },
    amazon_translated_content: {
      type: Object,
      default: () => {}
    },
    keyword_sidebar_open: {
      type: Boolean,
      default: false
    },
    show_comparison: {
      type: Boolean,
      default: false
    },
    show_translation: {
      type: Boolean,
      default: false
    },
    suggested_keywords: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      charactersMap: {
        product_name: {
          min: 50,
          max: 75
        },
        item_highlight: {
          min: 80,
          max: 125
        },
        generic_keyword: {
          min: 100,
          max: 250
        },
        product_description: {
          min: 1000,
          max: 2000
        },
        bullet_points: {
          min: 50,
          max: 300
        }
      },
      show_amazon_version: false,
      omny_text_with_diffs: "",
      amazon_text_with_diffs: "",
      attribute_title_map: {
        product_name: "Product title",
        item_highlight: "Item highlight",
        bullet_points: ["Bullet point 1", "Bullet point 2", "Bullet point 3", "Bullet point 4", "Bullet point 5", "Bullet point 6", "Bullet point 7", "Bullet point 8", "Bullet point 9"],
        generic_keyword: "Search keywords",
        product_description: "Product description"
      },
      attribute_key_map: {
        product_name: "product_name",
        item_highlight: "item_highlight",
        bullet_points: ["bullet_point_1", "bullet_point_2", "bullet_point_3", "bullet_point_4", "bullet_point_5", "bullet_point_6", "bullet_point_7", "bullet_point_8", "bullet_point_9"],
        generic_keyword: "generic_keyword",
        product_description: "product_description"
      }
    };
  },
  created() {
    this.computeComparison();
  },
  computed: {
    amazonContent() {
      return {
        product_name: this.amazon?.product_name ?? "",
        item_highlight: this.amazon?.item_highlight ?? "",
        generic_keyword: this.amazon?.generic_keyword ?? "",
        product_description: this.amazon?.product_description ?? "",
        bullet_points: [this.amazon.bullet_point_1, this.amazon.bullet_point_2, this.amazon.bullet_point_3, this.amazon.bullet_point_4, this.amazon.bullet_point_5]
      }[this.type] ?? "";
    },
    amazonContentTranslation() {
      let content = {
        product_name: this.amazon_translated_content?.product_name ?? "",
        item_highlight: this.amazon_translated_content?.item_highlight ?? "",
        generic_keyword: this.amazon_translated_content?.generic_keyword ?? "",
        product_description: this.amazon_translated_content?.product_description ?? "",
        bullet_points: [this.amazon_translated_content?.bullet_point_1 ?? "", this.amazon_translated_content?.bullet_point_2 ?? "", this.amazon_translated_content?.bullet_point_3 ?? "", this.amazon_translated_content?.bullet_point_4 ?? "", this.amazon_translated_content?.bullet_point_5 ?? ""].filter(Boolean)
      }[this.type];
      return content == false ? "" : content;
    },
    omnyContentTranslation() {
      let content = {
        product_name: this.omny_translated_content?.product_name ?? "",
        item_highlight: this.omny_translated_content?.item_highlight ?? "",
        generic_keyword: this.omny_translated_content?.generic_keyword ?? "",
        product_description: this.omny_translated_content?.product_description ?? "",
        bullet_points: [this.omny_translated_content?.bullet_point_1 ?? "", this.omny_translated_content?.bullet_point_2 ?? "", this.omny_translated_content?.bullet_point_3 ?? "", this.omny_translated_content?.bullet_point_4 ?? "", this.omny_translated_content?.bullet_point_5 ?? ""].filter(Boolean)
      }[this.type];
      return content == false ? "" : content;
    },
    aiContent() {
      return this.show_ai_translated_content && this.translateContent || this.show_ai_generated_content && this.aiGenerateContent;
    },
    aiContentTranslate() {
      return this.show_ai_generated_content && this.aiGenerateContentTranslate;
    },
    aiContentTitle() {
      return this.show_ai_translated_content && "AI Translated Content" || this.show_ai_generated_content && "AI proposition";
    },
    translateContent() {
      let content = {
        product_name: this.ai_translated_content?.product_name ?? "",
        item_highlight: this.ai_translated_content?.item_highlight ?? "",
        generic_keyword: this.suggested_keywords ?? this.amazon?.generic_keyword,
        product_description: this.ai_translated_content?.product_description ?? "",
        bullet_points: [this.ai_translated_content?.bullet_point_1 ?? "", this.ai_translated_content?.bullet_point_2 ?? "", this.ai_translated_content?.bullet_point_3 ?? "", this.ai_translated_content?.bullet_point_4 ?? "", this.ai_translated_content?.bullet_point_5 ?? ""].filter(Boolean)
      }[this.type];
      return content == false ? "" : content;
    },
    aiGenerateContent() {
      let content = {
        product_name: [this.ai_generated_content?.product_name_1 ?? "", this.ai_generated_content?.product_name_2 ?? "", this.ai_generated_content?.product_name_3 ?? ""],
        item_highlight: this.ai_generated_content?.item_highlight ?? "",
        generic_keyword: this.ai_generated_content?.generic_keyword ?? "",
        product_description: this.ai_generated_content?.product_description ?? "",
        bullet_points: [this.ai_generated_content?.bullet_point_1 ?? "", this.ai_generated_content?.bullet_point_2 ?? "", this.ai_generated_content?.bullet_point_3 ?? "", this.ai_generated_content?.bullet_point_4 ?? "", this.ai_generated_content?.bullet_point_5 ?? "", this.ai_generated_content?.bullet_point_6 ?? "", this.ai_generated_content?.bullet_point_7 ?? "", this.ai_generated_content?.bullet_point_8 ?? "", this.ai_generated_content?.bullet_point_9 ?? ""].filter(Boolean)
      }[this.type];
      return content == false ? "" : content;
    },
    aiGenerateContentTranslate() {
      let content = {
        product_name: [this.ai_generated_content_translation?.product_name_1 ?? "", this.ai_generated_content_translation?.product_name_2 ?? "", this.ai_generated_content_translation?.product_name_3 ?? ""],
        item_highlight: this.ai_generated_content_translation?.item_highlight ?? "",
        generic_keyword: this.ai_generated_content_translation?.generic_keyword ?? "",
        product_description: this.ai_generated_content_translation?.product_description ?? "",
        bullet_points: [this.ai_generated_content_translation?.bullet_point_1 ?? "", this.ai_generated_content_translation?.bullet_point_2 ?? "", this.ai_generated_content_translation?.bullet_point_3 ?? "", this.ai_generated_content_translation?.bullet_point_4 ?? "", this.ai_generated_content_translation?.bullet_point_5 ?? "", this.ai_generated_content_translation?.bullet_point_6 ?? "", this.ai_generated_content_translation?.bullet_point_7 ?? "", this.ai_generated_content_translation?.bullet_point_8 ?? "", this.ai_generated_content_translation?.bullet_point_9 ?? ""].filter(Boolean)
      }[this.type];
      return content == false ? "" : content;
    },
    omnyContent: {
      get() {
        return {
          product_name: this.modelValue?.product_name ?? "",
          item_highlight: this.modelValue?.item_highlight ?? "",
          generic_keyword: this.modelValue?.generic_keyword ?? "",
          product_description: this.modelValue?.product_description ?? "",
          bullet_points: [this.modelValue.bullet_point_1, this.modelValue.bullet_point_2, this.modelValue.bullet_point_3, this.modelValue.bullet_point_4, this.modelValue.bullet_point_5]
        }[this.type] ?? "";
      },
      set(val) {
        const newValue = {
          ...this.modelValue
        };
        const updateBulletPointsAttribute = (newVal, val) => {
          for (const index in val) {
            newVal[`bullet_point_${index * 1 + 1}`] = val[index];
          }
          return newVal;
        };
        const updateAttribute = (newVal, val) => {
          newVal[this.type] = val;
          return newVal;
        };
        let result = this.type == "bullet_points" ? updateBulletPointsAttribute(newValue, val) : updateAttribute(newValue, val);
        this.$emit("update:modelValue", result);
      }
    },
    characterRangePerContentType() {
      return type => {
        return this.charactersMap[type];
      };
    }
  },
  watch: {
    show_comparison() {
      if (this.show_comparison) {
        this.computeComparison();
      }
    }
  },
  methods: {
    ...mapActions(["contentApplySuggestedKeywords", "simpleTranslationGet"]),
    isValid(value) {
      this.$emit("checkIsValid", {
        type: value.type,
        index: value.index,
        valid: value.valid
      });
    },
    onAdd(val) {
      this.omnyContent = val;
    },
    computeComparison() {
      const dmp = new DiffMatchPatch();
      if (typeof this.amazonContent === "string") {
        const diffs = dmp.diff_main(this.amazonContent, this.omnyContent);
        dmp.diff_cleanupSemantic(diffs);
        this.amazon_text_with_diffs = generateHtmlDiff(diffs, "text1");
        this.omny_text_with_diffs = generateHtmlDiff(diffs, "text2");
        return;
      }
      this.amazon_text_with_diffs = [];
      this.omny_text_with_diffs = [];
      this.amazonContent.forEach((item, index) => {
        const diffs = dmp.diff_main(item, this.omnyContent[index]);
        dmp.diff_cleanupSemantic(diffs);
        this.amazon_text_with_diffs.push(generateHtmlDiff(diffs, "text1"));
        this.omny_text_with_diffs.push(generateHtmlDiff(diffs, "text2"));
      });
    },
    typeOfContentIsString(aContent) {
      return typeof aContent == "string";
    },
    hideComparison() {
      this.$emit("hide-comparison");
    },
    hideTranslation() {
      this.$emit("hide-translation");
    }
  }
};